import React from "react";
import uiConfig from "../../config/uiConfig";


import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress
} from "@mui/material";


import EmployeeForm from "./EmployeeForm";





function EmployeeDialog({

  open,

  employee,

  isSaving = false,

  onClose,

  onSave

}) {



return (


<Dialog

open={open}

onClose={onClose}

maxWidth="sm"

fullWidth

PaperProps={{

sx:{

borderRadius:3,

overflow:"hidden"

}

}}

>





<DialogTitle

sx={{

px:3,

pt:2.5,

pb:1.5

}}

>

<Box>


<Typography

sx={{

fontSize:"22px",

fontWeight:700,

color:"text.primary",

lineHeight:1.2

}}

>

{

employee

?

"Update Employee"

:

"Add Employee"

}


</Typography>




<Typography

sx={{

fontSize:13,

color:"text.secondary",

mt:0.6

}}

>

Add employee profile details and map them to a department.

</Typography>


</Box>


</DialogTitle>







<DialogContent

sx={{

px:3,

py:2.5,

borderColor:"divider"

}}

dividers

>


<EmployeeForm


employee={employee}


onSubmit={onSave}


/>


</DialogContent>









<DialogActions

sx={{

px:3,


py:2,

gap:1.5,

borderTop:"1px solid",

borderColor:"divider"

}}

>


<Button

variant="outlined"

onClick={onClose}

disabled={isSaving}

sx={{

textTransform:"none",

borderRadius:2

}}

>

Cancel

</Button>







<Button

variant="contained"

type="submit"

form="employee-form"

disabled={isSaving}

startIcon={isSaving ? <CircularProgress size={16} color="inherit" /> : null}

sx={{

textTransform:"none",

background:uiConfig.buttonColor,

borderRadius:2,

px:3,

boxShadow:"none",

"&:hover":{

background:"#1d4ed8",

boxShadow:"none"

}

}}

>

{isSaving ? "Saving..." : "Save"}

</Button>





</DialogActions>







</Dialog>


);


}


export default EmployeeDialog;